const funcion4 = {
    titulo: `Función: parámetros de tipo objeto`,
    problemas: [
      {
        codigo:1,
        descripcion: `Un <strong>objeto</strong> también es una estructura de datos que permite almacenar un <strong>conjunto</strong> de datos con una organización distinta a los Array. Pero en cuanto al funcionamiento o comportamiento como parámetros es idéntica a los Array.
Cuando pasamos un objeto como parámetro, si en la función modificamos las propiedades, luego el objeto que se ha pasado se modifica también (recordemos que esto no sucede con parámetros de tipo number, string y boolean)`,
programa: `function aumentarEdad(persona) {
  persona.edad++
}

const persona1 = {
  nombre: 'Juan',
  edad: 20
}
aumentarEdad(persona1)
console.log(persona1)
`,
        solucion: "{nombre:'Juan', edad: 21}"
      },{
        codigo:2,
        descripcion: `Podemos no solamente cambiar los valores de propiedades del objeto que le enviamos a la función, sino también crear nuevas propiedades.`,
programa: `function fijarStock100(producto) {
  producto.stock = 100
}

const producto1 = {
  descripcion: 'papas',
  precio: 50.43
}

fijarStock100(producto1)
console.log(producto1)
`,
        solucion: "{descripcion:'papas', precio: 50.43, stock: 100}"
      },{
        codigo:3,
        descripcion: ``,
programa: `const pelicula1 = {
  titulo: "El padrino",
  director: "Francis Ford Coppola",
  fecha: "1972"
}

function fijarPaisItalia(pelicula) {
  pelicula.pais = "Italia"
}

fijarPaisItalia(pelicula1)
console.log(pelicula1.pais)
`,
        solucion: "'Italia'"
      },{
        codigo:4,
        descripcion: ``,
programa: `const sitioWeb = {
    url: 'https://www.google.com',
    nombre: 'Google',
    descripcion: 'Buscador de la web',
    icono: 'https://www.google.com/favicon.ico'
  }

  function cambiarUrl(sitioWeb) {
    sitioWeb['url'] = 'https://www.yahoo.com'
  }

  cambiarUrl(sitioWeb)
  console.log(sitioWeb.url)
`,
        solucion: "'https://www.yahoo.com'"
      },{
        codigo:5,
        descripcion: `Las propiedades de un objeto pueden tener espacios en blanco, luego cuando las declaramos al crear el objeto debemos utilizar las comillas simples o dobles.
Cuando debemos acceder al valor de la propiedad debemos utilizar obligatoriamente la sintaxis de subíndices con corchetes y no la del operador punto.
Si bien uno podría utilizar como regla el no empleo del espacio en blanco, en algunas situaciones los objetos que consumimos provienen de otras aplicaciones, por ejemplo de un servidor de Internet con dicho formato.`,
programa: `let persona1 = {
    "apellido y nombre": "Perez, Juan",
    edad: 30,
    estudios: true
  }

  function cambiarApellidoNombre(persona) {
    persona["apellido y nombre"] = "Castro, Ana"
  }

  cambiarApellidoNombre(persona1)
  console.log(persona1)
`,
        solucion: "{'apellido y nombre': 'Castro, Ana', edad: 30, estudios: true}"
      },{
        codigo:6,
        descripcion: `Dentro de la función también podemos eliminar propiedades del objeto.`,
programa: `const pelicula1 = {
    titulo: "El padrino",
    director: "Francis Ford Coppola",
    fecha: "1972"
  }

  function eliminarFecha(pelicula) {
    delete pelicula.fecha
  }

  eliminarFecha(pelicula1)
  console.log(pelicula1)
`,
        solucion: "{titulo: 'El padrino', director: 'Francis Ford Coppola'}"
      }
    ]
  }

export default funcion4;